<template>
    <template v-if="type == 'small-icon' ">

        <div class="price-qty">
            <div class="counter-number" v-if="in_cart">
                <div class="counter">
                    <div class="qty-left-minus" data-type="minus" data-field="" @click="updateCart(quantity - 1)">
                        <i class="fa-solid fa-minus"></i>
                    </div>

                    <input class="form-control input-number qty-input" type="text" name="quantity" :value="quantity" readonly>

                    <div class="qty-right-plus" data-type="plus" data-field="" @click="updateCart(quantity + 1)">
                        <i class="fa-solid fa-plus"></i>
                    </div>
                </div>
            </div>

            <button class="buy-button btn btn-cart" v-if="!in_cart" @click="updateCart(1)">
                <i class="iconly-Buy icli text-white m-0"></i>
            </button>

            <button class="buy-button buy-button-2 btn" v-else>
                <router-link :to="{ name: 'cart_items.index', params: { lang: $i18n.locale } }">
                    <i class="iconly-Buy icli text-white m-0"></i>
                </router-link>
            </button>
        </div>

    </template>
    <template v-if="type == 'box' ">

        <div class="product-packege" v-if="product?.prices?.length > 0">
            <ul class="select-packege d-flex justify-content-evenly">
                <li v-for="price in product.prices" :key="price.id">
                    <a href="javascript:void(0)" :class="{ active: isSelectedPrice(price) }" @click="selectPrice(price)" @dblclick="removePrice()">
                        {{ price?.name }}
                        <h3 class="price" :class="{'theme-color': !isSelectedPrice(price)}">
                            {{ price?.price_tax }}
                            <span class="regular-price">{{ $t('SAR') }}</span>
                        </h3>
                    </a>
                </li>
            </ul>
        </div>

        <div class="add-to-cart-box bg-white" v-if="(product?.prices?.length > 0 && selected_price != null) || (product?.prices?.length === 0 || product?.prices == null)">
            <button class="btn btn-add-cart addcart-button" v-if="!in_cart" @click="updateCart(1)">
                {{ $t('Add to gift box') }}
                <span class="add-icon bg-light-gray">
                    <i class="fa-solid fa-plus"></i>
                </span>
            </button>

            <div class="cart_qty qty-box" v-if="in_cart">
                <div class="input-group bg-white" style="direction: ltr;">
                    <button type="button" class="qty-left-minus bg-gray" data-type="minus" data-field="" @click="updateCart(quantity - 1)">
                        <i class="fa fa-minus" aria-hidden="true"></i>
                    </button>

                    <input class="form-control input-number qty-input" type="text" name="quantity" :value="quantity" readonly>

                    <button type="button" class="qty-right-plus bg-gray" data-type="plus" data-field="" @click="updateCart(quantity + 1)">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>

    </template>
    <template v-if="type == 'big' ">

        <div class="product-packege" v-if="product?.prices?.length > 0">
            <div class="product-title">
                <h4>اختر النوع</h4>
            </div>
            <ul class="select-packege">
                <li v-for="price in product.prices" :key="price.id">
                    <a href="javascript:void(0)" :class="{ active: isSelectedPrice(price) }" @click="selectPrice(price)" @dblclick="removePrice()">
                        {{ price?.name }}
                        <h3 class="price" :class="{'theme-color': !isSelectedPrice(price)}">
                            {{ price?.price_tax }}
                            <span class="regular-price">{{ $t('SAR') }}</span>
                        </h3>
                    </a>
                </li>
            </ul>
        </div>

        <div class="product-packege" v-for="attribute in product?.attributes">
            <div class="product-title">
                <h4>{{ attribute?.data?.name }}</h4>
            </div>
            <ul class="select-packege">
                <li v-for="attribute_item in attribute.items" :key="attribute_item.id">
                    <a href="javascript:void(0)" :class="{ active: isSelected(attribute, attribute_item) }" @click="selectAttribute(attribute, attribute_item)" @dblclick="removeAttribute(attribute)">
                        {{ attribute_item.value }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="note-box product-packege" v-if="(product?.prices?.length > 0 && selected_price != null) || (product?.prices?.length === 0 || product?.prices == null)">
            <div class="note-box product-packege" v-if="in_cart">
                <div class="cart_qty qty-box product-qty">
                    <div class="input-group" style="direction: ltr;">
                        <button type="button" class="qty-left-minus" data-type="minus" data-field="" @click="updateCart(quantity - 1)">
                            <i class="fa fa-minus" aria-hidden="true"></i>
                        </button>

                        <input class="form-control input-number qty-input" type="text" name="quantity" :value="quantity">

                        <button type="button" class="qty-right-plus" data-type="plus" data-field="" @click="updateCart(quantity + 1)">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>

            <button class="btn btn-md bg-dark cart-button text-white w-100" v-if="!in_cart" @click="updateCart(1)">
                {{ $t('Add to gift box') }}
            </button>
        </div>

    </template>
</template>

<script>
import store from './store'; // Replace with the actual path to your store

export default {
    inject: ['auth'],
    props: ['product', 'type','cart'],
    data() {
        return {
            selected_price: this.getCartDetail('selected_price'),
            selected_attributes: this.getCartDetail('selected_attributes') ?? {},
            quantity: this.getCartDetail('quantity') ?? 0,
        };
    },
    computed: {
        in_cart() {
            return store.getters.cartItems.some(item => {
                return item.product.id === this.product.id;
            }) || this.quantity > 0;
        }
    },
    methods: {
        getCartDetail(detail) {
            return this.cart?.[detail] ?? this.product.cart?.[detail];
        },
        isSelected(attribute, item) {
            return this.selected_attributes[attribute.data.id] === item.id;
        },
        async selectAttribute(attribute, item) {
            if (this.isSelected(attribute, item)) {
                delete this.selected_attributes[attribute.data.id];
            } else {
                this.selected_attributes[attribute.data.id] = item.id;
            }
            await this.sendRequest();
        },
        async removeAttribute(attribute) {
            delete this.selected_attributes[attribute.data.id];
            await this.sendRequest();
        },
        isSelectedPrice(price) {
            return this.selected_price?.id === price.id;
        },
        async selectPrice(price) {
            this.selected_price = price;
            await this.sendRequest();
        },
        async removePrice() {
            this.selected_price = null;
            await this.sendRequest();
        },
        async updateCart(newQuantity) {
            if (this.auth.isLoggedIn() === false) {
                this.$router.push({ name: 'login', params: { lang: this.$i18n.locale } });
                window.scrollTo(0, 0);
                return null;
            }

            if (newQuantity >= 0) {
                this.quantity = newQuantity;
            }

            if (this.quantity >= 1) {
                await this.sendRequest();
            } else {
                this.removeFromCart();
            }
        },
        async removeFromCart() {
            console.log('--- removeFromCart');
            console.log(this.product?.cart?.id );
            console.log( this.cart?.id);
            await store.dispatch('removeFromCart', this.product?.cart?.id ?? this.cart?.id);

            this.selected_price = null;
            this.selected_attributes = {};
            this.quantity = 0;

            // await store.dispatch('removeFromCart', { product: this.product, cart: this.cart });
        },
        async sendRequest() {
            if (this.quantity > 0) {
                const response = await store.dispatch('addToCart', {
                    product: this.product,
                    quantity: this.quantity,
                    selected_attributes: this.selected_attributes,
                    selected_price_id: this.selected_price?.id
                });
                console.log('----  sendRequest');
                // console.log(response.data);
                // this.cart = response.data;
                // this.$set(this, 'cart', response.data); // استخدم Vue.set هنا
                this.product.cart = response.data;

            }
        }
    },
    async created() {
        this.selected_attributes = this.getCartDetail('selected_attributes') ?? {};
        this.selected_price = this.getCartDetail('selected_price');
        this.quantity = this.getCartDetail('quantity') ?? 0;
    }
}
</script>
